<router-outlet></router-outlet>
@if (confetti) {
    <app-confetti></app-confetti>
}
